import Api from '@/services/Api'

export default {
  // send order confirmation email
  orderConf (orderinfo) {
    return Api().post('mail/orderconf', orderinfo)
  }
}



// WEBPACK FOOTER //
// ./src/services/MailService.js